import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Button from '~components/button';

const NoResults = ({ accountType, listingRedirect }) => {
  const intl = useIntl();

  return (
    <div className="c-matches__no-results">
      <FiSearch />
      <strong>
        {intl.formatMessage({
          id: 'containers.chats.list.no-favorites',
          defaultMessage: 'You have no recent chats.',
        })}
      </strong>
      <Link to={listingRedirect}>
        <Button type="button" className="c-btn c-matches__subscription-text l-grey">
          {accountType === 'worker'
            ? intl.formatMessage({ id: 'containers.chats.list.view-clients', defaultMessage: 'View customers' })
            : intl.formatMessage({ id: 'containers.chats.list.view-workers', defaultMessage: 'View workers' })}
        </Button>
      </Link>
    </div>
  );
};

export default NoResults;
